module.exports = __webpack_public_path__ + "img/logo.c9b1706.png";